module.exports = __webpack_public_path__ + "static/media/arrow-w.0d809b3f.svg";